<template>
  <div>
    <section class="section is-marginless is-paddingless">
      <ImageC
        @ready="!imageCReady ? (imageCReady = true) : false"
        link="/projekt"
        :items="items"
      ></ImageC>
    </section>

    <section class="section mt mb">
      <div class="container">
        <ProjectImages
          v-if="imageCReady"
          :items="items"
          :hidden="true"
        ></ProjectImages>
      </div>
    </section>

    <section class="section mb mt feature-bg">
      <div class="container">
        <Features v-if="imageCReady" id="features" class="seen"></Features>
      </div>
    </section>
  </div>
</template>

<script>
import ImageC from "@/components/singles/ImageC.vue";
import ProjectImages from "@/components/main/ProjectImages.vue";
import Features from "@/components/main/Features.vue";

export default {
  components: { ImageC, ProjectImages, Features },
  data() {
    return {
      featuresAnimate: false,
      imagesAnimate: false,
      items: [],
      imageCReady: false,
    };
  },
  async created() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.CheckScroll);
    this.fields = await this.$helpers.GetPageFields(this.fields);
    await this.GetProjects();
    this.ready = true;
  },
  mounted() {},
  destroyed() {
    window.removeEventListener("scroll", this.CheckScroll);
  },
  methods: {
    async CheckScroll() {
      if (!this.featuresAnimate) {
        const result = await this.$helpers.CheckViewPort("features");
        if (result) {
          this.featuresAnimate = true;
        }
      }
    },
    OrderItems(items) {
      return [...items].sort((a, b) => {
        if (a.card.order > b.card.order) {
          return 1;
        }
        if (b.card.order > a.card.order) {
          return -1;
        }

        return 0;
      });
    },
    async GetProjects() {
      let result = await this.$helpers.PostApi(
        "get/pageCards",
        {
          pageName: "/",
          active: true,
          cover: true,
        },
        true
      );

      this.items = this.OrderItems(result);
    },
  },
};
</script>
